import { action, observable, runInAction } from 'mobx';
import { CalendarEventEditForm } from 'application/schedule/forms';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext, toDate, toUTCDate, getErrorMessage } from 'core/utils';
import { ScheduleService } from 'application/schedule/services';
import { FacilityOrderService } from "application/facility-order/services";
import { PickTicketHeaderService } from "application/pick-ticket/services";
import { PersonService } from 'application/person/services';
import _ from 'lodash';
import { noteTypeEnum } from '../enums';
import { ModalParams } from 'core/models';

@applicationContext
class CalendarEventEditStore extends BaseEditViewStore {
    // @observable pastOrders = [];
    @observable accessor statistic = null;
    @observable accessor partBOnly = false;
    @observable accessor isPandaDoc = false;
    @observable accessor isOrderingCalType = false;
    constructor(rootStore, componentProps) {
        const id = componentProps.modalParams.data.id;
        const service = //componentProps.modalParams.data.deliveryCalendarSelected ? 
            new ScheduleService(rootStore.application.baasic.apiClient)
        // new OrderingScheduleService(rootStore.application.baasic.apiClient);   
        const personService = new PersonService(rootStore.application.baasic.apiClient);
        const modalParams = componentProps.modalParams;
        const isOrderingCalType = componentProps.modalParams.data.isOrderingCalType;
        super(rootStore, {
            name: 'event',
            id: id,
            Form: CalendarEventEditForm,
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await service.get(id, { embed: 'Facility,AreaOfCare,AccountRep,BillingRep,DocumentRep,PayorRep,IntakeRep,Facility.FacilityAreaOfCares,Facility.ESignPreference,FacilityScheduleDates,Assignee,Facility.Corporate_,FacilityOrder,FacilityOrder.ImportHeaderStatus' });
                        if (response.data.facility && response.data.facility.id) {
                            this.getStatistic(response.data.facility.id);
                        }
                        let isEnternal = response.data.facility.facilityAreaOfCares.find(x => x.areaOfCare.abrv == "enteral");
                        let isCoverageTypeAll = isEnternal && isEnternal.coverageType.abrv == "all";
                        this.partBOnly = response.data.facility.partBOnly;
                        this.isPandaDoc = response.data.facility.eSignPreference && response.data.facility.eSignPreference.name === 'Directly to medical providers';
                        this.isOrderingCalType = isOrderingCalType;
                        let isAreaOfCareWoundCare = response.data.areaOfCare && response.data.areaOfCare.abrv === "wound-care";
                        response.data = { ...response.data, isCoverageTypeAll: isCoverageTypeAll, isAreaOfCareWoundCare: isAreaOfCareWoundCare }
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(_.extend(this.item, resource));
                        return response.data;
                    }
                }
            },
            FormClass: CalendarEventEditForm,
        });

        this.modalParams = modalParams;
        this.titleData = this.modalParams.data;

        this.service = service;
        this.billingRepStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async (term) => {
                const response = await personService.find({ searchQuery: term, rpp: 200, sort: 'lastName|asc', fields: "id,firstName,lastName", isActive: true });
                return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.firstName + ' ' + item.lastName
                    };
                });
            }
        });
        this.documentRepStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async (term) => {
                const response = await personService.find({ searchQuery: term, rpp: 200, sort: 'lastName|asc', fields: "id,firstName,lastName", isActive: true });
                return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.firstName + ' ' + item.lastName
                    };
                });
            }
        });
        this.payorRepStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async (term) => {
                const response = await personService.find({ searchQuery: term, rpp: 200, sort: 'lastName|asc', fields: "id,firstName,lastName", isActive: true });
                return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.firstName + ' ' + item.lastName
                    };
                });
            }
        });
        this.intakeRepStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async (term) => {
                const response = await personService.find({ searchQuery: term, rpp: 200, sort: 'lastName|asc', fields: "id,firstName,lastName", isActive: true });
                return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.firstName + ' ' + item.lastName
                    };
                });
            }
        });

        this.accountRepStore = new BaasicDropdownStore({
            filterable: true
        }, {
            fetchFunc: async (term) => {
                const response = await personService.find({ searchQuery: term, rpp: 200, sort: 'lastName|asc', fields: "id,firstName,lastName", isActive: true });
                return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.firstName + ' ' + item.lastName
                    };
                });
            }
        });

        this.onDateChange = (item) => {
            this.form.set({ date: item.date });
        };

        this.navigateToFacility = (route) => {
            this.rootStore.routerStore.setTransitionData({
                navigationTitle: this.item.facility.name
            });
            const url = 'master.app.main.facility.' + route;
            return this.rootStore.routerStore.goTo(url,
                { id: this.item.facility.id }
            );
        }

        this.prepDayConfirmationModal = new ModalParams({});
    }

    // @action.bound
    // async getPastOrders(date, facilityId, calendarTypeId){
    //     let today = new Date();
    //     let dateD = new Date(date)

    //     if(dateD <= today)
    //         return;

    //     let params = {
    //         sort: 'date|desc',
    //         date:  date,
    //         facilityId: facilityId,
    //         embed: 'Facility,AreaOfCare',
    //         calendarTypeId: calendarTypeId,
    //         fields: 'id,date,facility,facility.name,areaOfCare,areaOfCare.name',
    //         numberOfDays: 30,
    //         rpp: 5
    //     };

    //     var response = await this.service.getPreviousTasks(params);
    //     if(response.data.item.length > 0)
    //     {
    //         let pastOrders = [
    //             _.extend(this.item, {
    //                 name: 'Current Date'
    //             })
    //         ].concat(_.map(response.data.item, item => {
    //             return _.extend(item, {
    //                 name: item.facility.name + (item.areaOfCare ? ', '+  item.areaOfCare.name : '')
    //             })
    //         }));
    //         this.pastOrders = pastOrders;        
    //     }
    // }

    @action
    async setItem(item) {
        this.item = item;
        this.itemInitialized = true;
        if (this.titleData == null || this.titleData.facility == null) {
            this.titleData = {
                ...this.titleData,
                date: toDate(item.date),
                facility: item.facility && item.facility.name,
                areaOfCare: item.areaOfCare && item.areaOfCare.name
            }
        }

        this.dateTitle = item.date;

        this.deliveryTask = item.facilityScheduleDates.find(x => x.facilityScheduleType.abrv === 'delivery');
        this.isDeliveryLink = this.deliveryTask != null;
        if (this.isDeliveryLink) {
            this.form.update({
                deliveryNotes: this.deliveryTask.notes
            })
        }
        this.dateOfService = item.dateOfService;
        this.orderingDate = item.date;
        this.deliveryDate = this.deliveryTask && this.deliveryTask.date;
        this.confirmingTask = item.facilityScheduleDates.find(x => x.facilityScheduleType.abrv === 'confirming');
        this.isConfirmingLink = this.confirmingTask != null;
        const userId = this.rootStore.userStore.user.id;
        const isAssignee = item.assignee != null && userId == item.assignee.userId;

        this.isPayorRepAssignee = item.payorRep != null && userId == item.payorRep.userId && isAssignee;
        this.isIntakeRepAssignee = item.intakeRep != null && userId == item.intakeRep.userId && isAssignee;
        this.isDocumentRepAssignee = item.documentRep != null && userId == item.documentRep.userId && isAssignee;
        this.isBillingRepAssignee = item.billingRep != null && userId == item.billingRep.userId && isAssignee;
        this.isUserAccountManager = item.accountRep != null && userId == item.accountRep.userId;

        const userRoles = this.rootStore.userStore.user.roles;
        this.isAdmin = userRoles.includes("Administrators");
        this.isAccountManager = userRoles.includes("AccountManager");
        this.isInitialIntake = userRoles.includes("InitialIntake");
        this.isInsuranceReview = userRoles.includes("InsuranceReview");
        this.isBiller = userRoles.includes("Biller");

        this.facilityNote = item.facility.notes;
        this.corporateNote = item.facility.corporate_ && item.facility.corporate_.description;
    }

    @action.bound
    async getResource(id) {
        await super.getResource(id);
        // await this.getPastOrders(this.item.date, this.item.facility.id, this.item.facilityScheduleTypeId);
    }

    @action.bound
    async getStatistic(facilityId) {
        const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
        const facilityStatistic = await facilityOrderService.getStatistic(facilityId);
        runInAction(() => {
            this.statistic = facilityStatistic && facilityStatistic.data;
        })
    }

    @action.bound
    async copyNote(noteType) {
        var note;
        if (noteType === noteTypeEnum.intakeNote) {
            note = this.form.$('intakeNote').value;
        }
        else if (noteType === noteTypeEnum.documentNote) {
            note = this.form.$('documentNote').value;
        }
        else if (noteType === noteTypeEnum.billingNote) {
            note = this.form.$('billingNote').value;
        }
        else if (noteType === noteTypeEnum.payorNote) {
            note = this.form.$('payorNote').value;
        }
        else if (noteType === noteTypeEnum.note) {
            note = this.form.$('notes').value;
        }
        try {
            await this.service.copyNote({
                id: this.item.id,
                note: note,
                noteType: noteType,
                facilityId: this.item.facility.id,
                areaOfCareId: this.item.areaOfCare && this.item.areaOfCare.id,
                date: this.item.date,
                facilityScheduleTypeId: this.item.facilityScheduleTypeId
            });
            this.rootStore.notificationStore.success("Notes successfully copied.");
        }
        catch (err) {
            this.rootStore.notificationStore.error("Error occured while copying.");
        }

    }

    @action.bound
    async updateResource(resource) {
        this.form.setFieldsDisabled(true);
        try {
            let originalDate = null;
            if (this.item.manuallyUpdated) {
                originalDate = this.item.originalDate;
            } else if (resource.date != this.item.date) {
                originalDate = resource.date;
            }

            await this.actions.update({
                id: this.id,
                manuallyUpdated: true,
                originalDate: originalDate,
                ...resource
            });

            if (this.isDeliveryLink) {
                await this.service.updateLinkedTask({
                    ...this.deliveryTask,
                    notes: resource.deliveryNotes,
                    noSupply: resource.noSupply,
                    sendOrder: resource.sendOrder,
                    isDone: resource.noSupply || this.deliveryTask.isDone
                });
            }

            if (this.isConfirmingLink) {
                await this.service.updateLinkedTask({
                    ...this.confirmingTask,
                    noSupply: resource.noSupply,
                    isDone: resource.noSupply || this.confirmingTask.isDone
                });
            }

            this.form.setFieldsDisabled(false);
            this.modalParams.close();
            if (this.modalParams.data.onSuccess) {
                this.modalParams.data.onSuccess();
            }

            this.rootStore.notificationStore.success("SCHEDULE.CALENDAR.EDIT.TASK_SUCCESS");
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error("Error occured while saving.");
        }
    }

    @action.bound
    async getFacilityOrderRoute() {
        const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
        let targetPage = (await facilityOrderService.getTargetPage(this.item.facilityOrderId)).data;
        targetPage = !targetPage || targetPage == '' ? 'preview' : targetPage == 'order-summary' ? targetPage : targetPage == 'billing' ? targetPage + '.preview' : targetPage + '-preview';
        return window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility-order.facility-order-new-flow.' + targetPage).pattern.replace(':id', this.item.facilityOrderId)}`, '_blank');
    }

    @action.bound
    async openPickTicket(facilityOrder, pickTicketHeaderId) {
        localStorage.setItem('refreshPickTicket', true);
        let route = facilityOrder.isNewFlow2 ? 'master.app.main.facility-order.pick-ticket-new-flow.list' : 'master.app.main.facility-order.pick-ticket.list';

        window.open(`${this.rootStore.routerStore
            .findRoute(route)
            .pattern.replace(":facilityOrderId", facilityOrder.id).replace(":pickTicketHeaderId", pickTicketHeaderId)}`);
    }

    @action.bound
    async openNikoFacilityOrder() {
        if (this.item.facilityOrderId) {
            return await this.getNikoFacilityOrderRoute();
        }
        else {
            const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
            let response = await facilityOrderService.find({ facilityId: this.item.facility.id, isNiko: true, isSendOrder: false });
            if (response && response.data && response.data.totalRecords > 0) {
                return this.rootStore.notificationStore.error(`A new order for this facility cannot be created until the previous one is sent. The order with DOS ${toUTCDate(response.data.item[0].dateOfService)} has not been sent yet.`);
            }
            else {
                if (this.isOlderThanDays(toUTCDate(this.orderingDate), 1)) {
                    await this.prepDayConfirmationModal.open({
                        onConfirm: async () => await this.createNikoFacilityOrder(),
                        message: "It's not yet prep day. Are you sure you want to start the order now?",
                        cancelLabel: 'MODAL.NO',
                        confirmLabel: 'MODAL.YES'
                    });
                }
                else {
                    await this.createNikoFacilityOrder();
                }
            }
        }
    }
    @action.bound
    async getNikoFacilityOrderRoute() {
        const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
        let targetPage = (await facilityOrderService.getNikoTargetPage(this.item.facilityOrderId)).data;
        return window.open(`${this.rootStore.routerStore.findRoute('master.app.main.niko-facility-order.' + targetPage + '-preview').pattern.replace(':id', this.item.facilityOrderId)}`, '_blank');
    }

    @action.bound
    async createNikoFacilityOrder() {
        this.form.setFieldsDisabled(true);
        try {
            const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
            await facilityOrderService.createNikoFacilityOrder(this.item.id);
            await super.getResource(this.item.id);
            this.rootStore.notificationStore.success("Facility Order successfully created.");
            await this.getNikoFacilityOrderRoute();
        }
        catch (err) {
            this.rootStore.notificationStore.error(getErrorMessage(err, 'Error occured while trying to create the facility order.'));
        }
        finally {
            this.form.setFieldsDisabled(false);
        }
    }

    @action.bound
    async downloadDeliveryTicketNiko() {
        const pickTicketHeaderService = new PickTicketHeaderService(this.rootStore.application.baasic.apiClient);
        const result = await pickTicketHeaderService.hasPickTicketItemsNiko(this.item.facilityOrderId, 'Delivery Ticket');
        if (!result.hasItems) {
            this.rootStore.notificationStore.error("There are no items to include on the Delivery Ticket.");
            return;
        }
        const url = `${pickTicketHeaderService.getDeliveryReportDownloadUrlNiko(this.item.facilityOrderId)}?contentDisposition=attachment&token=${this.rootStore.authStore.token.tokenUrl}&ttype=${this.rootStore.authStore.token.type}`;
        window.open(url);
    }

    @action.bound
    isOlderThanDays(date, days) {
        const d1 = new Date();
        d1.setHours(0, 0, 0, 0);
        const d2 = new Date(date);
        d2.setHours(0, 0, 0, 0);
        const diffDays = (d2 - d1) / (1000 * 60 * 60 * 24);
        return diffDays > days;
    }
}

export default CalendarEventEditStore;
